export class AuditLogFilter {
  NewValue: string;

  constructor() {
    this.NewValue = null;
  }
}

